import React, { useContext } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { Button, Container, createStyles, makeStyles, Paper, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { LogoutRequiredForm } from "../../../../authentication/components/LogoutRequiredForm";
import { RootContext } from "../../../../../stores";
import { IAdminInvitationFlowValues } from "../../_interfaces/IAdminInvitationFlowValues";
import { OrganizationProfileLimitStepValues } from "../../_interfaces/IAdminInvitationStepTypeValues";
import { useOrganizationProfileLimitController } from "../../hooks/useOrganizationProfileLimitController";
import { AdminInvitationHeader } from "../AdminInvitationHeader";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(4),
            display: 'inline-block',
            position: 'relative' // the loading spinner refers to this element
        },
        alert: {
            textAlign: 'left',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: theme.spacing(3),
            maxWidth: 900
        },
        button: {
            marginTop: theme.spacing(1),
            display: 'block'
        }
    })
);

export const OrganizationProfileLimitStep: React.FC<
    StepRenderProps<OrganizationProfileLimitStepValues, IAdminInvitationFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useOrganizationProfileLimitController(values, allValues, update, submit);
    const rootStore = useContext(RootContext);

    /********* Event handlers *********/

    const onContactUsClicked = () => {
        rootStore.navigationStore.appwideDialogStates.contactUsDialog.setOpen(true);
        rootStore.helpStore.setHelpMessageOverrides({
            subject: 'Organization Admin Profiles Limit Increase Request',
        });
    };

    /********* Render *********/

    return (
        <Container>
            <Paper className={classes.content}>
                <Alert severity="error" className={classes.alert}>
                    <AlertTitle>Maximum Organization Admin Profiles Reached</AlertTitle>
                    You've reached the maximum number of organization admin profiles allowed for a single user account. If you would like to proceed by creating a new user account, please logout below. If you would like to increase your limit, please contact us for support.
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={onContactUsClicked}
                    >
                        Contact Us
                    </Button>
                </Alert>
                <AdminInvitationHeader organizationName={allValues.organizationName || ""} />
                <LogoutRequiredForm
                    values={controller.values}
                    onChange={(patch) => {
                        controller.onChange(patch);
                        update(patch); // sync with Flow
                    }}
                    onSubmit={controller.onSubmit}
                    isSubmitting={controller.isSubmitting}
                    error={controller.error}
                    fieldErrors={controller.fieldErrors}
                />
            </Paper>
        </Container>
    );
});